<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('POSTS.LIST_HEADER') }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn dark color="indigo" @click="create">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('POSTS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <item-list @edit="edit" />
  </div>
</template>

<script>
export default {
  name: 'PostsPage',

  components: {
    ItemList: () => import('@/modules/posts/components/PostsList.vue')
  },

  data: () => ({
    dialog: false
  }),

  computed: {},

  created() {},

  methods: {
    edit(item) {
      this.$router.push({
        name: 'posts.edit',
        params: { id: item.id }
      });
    },
    create() {
      this.$router.push({
        name: 'posts.create'
      });
    }
  }
};
</script>
